import type { TranslationMessages } from '../types';

export const wizards: TranslationMessages = {
  manager: {
    title: 'Feature Guide',
    description: 'Discover and learn about features in NEKO POS',
    searchPlaceholder: 'Search features...',
    resetWizard: 'Reset Wizard',
    resetAll: 'Reset All Wizards',
  },
  modernOrderList: {
    welcome: {
      title: 'Welcome to Modern Order List',
      description: 'A powerful, responsive order management interface',
      info: 'This is the new and improved order list interface',
      content:
        'The modern order list provides enhanced search, filtering, and management capabilities.',
    },
    search: {
      title: 'Advanced Search',
      description: 'Search orders by customer, product, or reference',
      highlight: 'Powerful Search',
      details: 'Search across multiple fields simultaneously',
      feature1: 'Multi-field Search',
      feature1Desc:
        'Search by customer name, product name, or order reference',
      feature2: 'Real-time Results',
      feature2Desc: 'See results update as you type',
    },
    responsive: {
      title: 'Responsive Design',
      description: 'Works perfectly on desktop and mobile',
      desktop: 'Desktop View',
      desktopDesc: 'Full-featured table view with all columns',
      mobile: 'Mobile View',
      mobileDesc: 'Optimized card layout for small screens',
      tip: 'The interface automatically adapts to your screen size',
    },
    bulkRelease: {
      title: 'Bulk Release',
      description: 'Release multiple tables at once',
      highlight: 'Bulk Actions',
      details: 'Select multiple orders and release tables together',
      feature1: 'Multi-select',
      feature1Desc: 'Select multiple orders using checkboxes',
      feature2: 'One-click Release',
      feature2Desc: 'Release all selected tables with a single action',
    },
    productNames: {
      title: 'Product Names',
      description: 'See product names instead of IDs',
      highlight: 'Product Display',
      details: 'Product names are automatically fetched and displayed',
      tip: 'Product names are cached for faster loading',
    },
    currencySettings: {
      title: 'Currency Settings',
      description: 'Configure currency display and formatting',
      highlight: 'Currency Configuration',
      details: 'Set your preferred currency and formatting options',
      feature1: 'Currency Selection',
      feature1Desc: 'Choose from available currencies',
      feature2: 'Formatting Options',
      feature2Desc: 'Customize how amounts are displayed',
      action: 'Configure Currency',
    },
    versionSwitcher: {
      title: 'Version Switcher',
      description: 'Switch between modern and classic interfaces',
      highlight: 'Interface Options',
      details:
        'Choose between the modern interface and the classic React Admin interface',
      tip: 'You can switch back to the classic interface anytime',
    },
    keywords: 'order, orders, list, search, filter, table, release',
  },
  products: {
    welcome: {
      title: 'Welcome to Products',
      description: 'Manage your product catalog',
      info: 'Create and manage your products',
      content: 'Add products, set prices, and organize by categories',
    },
    manage: {
      title: 'Manage Products',
      description: 'Create and edit products',
      highlight: 'Product Management',
      details: 'Full CRUD operations for products',
      step1: 'Create products with names, prices, and descriptions',
      step2: 'Organize products into categories',
      action: 'Go to Products',
    },
    settings: {
      title: 'Product Settings',
      description: 'Configure product-related settings',
      highlight: 'Settings',
      details: 'Customize product display and behavior',
      tip: 'Settings affect how products are displayed throughout the system',
    },
    keywords: 'product, products, catalog, category, price',
  },
  };
